import axiosInstance from '../config/axios.js';

const API_BASE = '/attendance';

const attendanceService = {
  // Login attendance
  loginAttendance: async (latitude, longitude) => {
    const response = await axiosInstance.post(`${API_BASE}/login`, {
      latitude,
      longitude
    });
    return response.data;
  },

  // Logout attendance
  logoutAttendance: async (latitude, longitude) => {
    const response = await axiosInstance.post(`${API_BASE}/logout`, {
      latitude,
      longitude
    });
    return response.data;
  },

  // Get active attendance status
  getActiveStatus: async () => {
    const response = await axiosInstance.get(`${API_BASE}/active-status`);
    return response.data;
  },

  // Get my attendances
  getMyAttendances: async (startDate = null, endDate = null) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    
    const response = await axiosInstance.get(`${API_BASE}/my-attendances`, { params });
    return response.data;
  },

  // Get my monthly report
  getMyMonthlyReport: async (year = null, month = null) => {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    
    const response = await axiosInstance.get(`${API_BASE}/my-monthly-report`, { params });
    return response.data;
  },

  // Get single attendance record by ID
  getById: async (attendanceId) => {
    const response = await axiosInstance.get(`${API_BASE}/${attendanceId}`);
    return response.data;
  },

  // Admin: Get user attendances WITH PAGINATION
  getUserAttendances: async (userId, page = 1, perPage = 10, startDate = null, endDate = null) => {
    const params = { page, per_page: perPage };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    
    const response = await axiosInstance.get(`${API_BASE}/user/${userId}/attendances`, { params });
    return response.data;
  },

  // Admin: Get user monthly report
  getUserMonthlyReport: async (userId, year = null, month = null) => {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    
    const response = await axiosInstance.get(`${API_BASE}/user/${userId}/monthly-report`, { params });
    return response.data;
  },

  // Admin: Get all users attendance summary
  getAllUsersAttendanceSummary: async (year = null, month = null) => {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    
    const response = await axiosInstance.get(`${API_BASE}/summary`, { params });
    return response.data;
  }
};

export default attendanceService;